import Component from 'antd/es/form';
import 'antd/lib/form/style';
export default Component;

